import React from "react"
import { Paper } from "material-ui"
import ClientIcon from "material-ui/svg-icons/action/perm-contact-calendar"
import { IClientDocument, IClientContactDocument } from "../../../models"
import * as utils from "../../../helpers/utils"
interface IProps {
    client: IClientDocument
}
interface IState {
    primaryContact: IClientContactDocument
    showClientDetail: boolean
}

export default class ClientDetailsTopbar extends React.Component<IProps, IState> {
    constructor(props, context) {
        super(props, context)
        this.state = {
            primaryContact: props.client.PrimaryContact ? props.client.PrimaryContact : null,
            showClientDetail: true,
        }
    }

    componentWillReceiveProps (newProps) {
        if(!utils.isEquivalentObjects(this.props.client.PrimaryContact, newProps.client.PrimaryContact)) {
            this.setState({ primaryContact: newProps.client.PrimaryContact, showClientDetail: false }, () => this.setState({ showClientDetail: true }))
        }
    }

    render() {
        let primaryContactName = `${this.state.primaryContact ? this.state.primaryContact.FirstName : ""} ${this.state.primaryContact ? this.state.primaryContact.LastName : ""}`
        if (this.state.primaryContact && this.state.primaryContact.PreferredName !== "" && this.state.primaryContact.PreferredName !== null) {
            if (this.state.primaryContact.LastName !== "" && this.state.primaryContact.LastName !== null) primaryContactName = `${this.state.primaryContact.PreferredName} ${this.state.primaryContact.LastName}`
            else primaryContactName = this.state.primaryContact.PreferredName
        }
        const primaryContactEmail = this.state.primaryContact && this.state.primaryContact.ContactInfo && this.state.primaryContact.ContactInfo.PrimaryEmail ? this.state.primaryContact.ContactInfo.PrimaryEmail.Email : ""
        const primaryContactPhone = this.state.primaryContact && this.state.primaryContact.ContactInfo && this.state.primaryContact.ContactInfo.MobilePhone ? this.state.primaryContact.ContactInfo.MobilePhone.PhoneNumber : ""
        return (
            <Paper
                zDepth={1}
                style={{ textAlign: "left", position: "relative", overFlow: "hidden", padding: 20, height: 90 }}
                className="paper-shadow"
            >
                <div>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                        <h2 style={{ marginTop: 13 }}>
                            {this.props.client.Name}
                        </h2>
                        <div style={{ display: "flex" }}>
                            <ClientIcon style={{ width: 33, height: 33, fill: "#95989a", marginRight: 20 }} />
                            {this.state.showClientDetail &&
                                <div style={{ marginTop: -8, textAlign: "right" }}>
                                    <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>{primaryContactName}</p>
                                    <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>{primaryContactEmail}</p>
                                    <p style={{ margin: 0, padding: 0, fontWeight: "bold" }}>{primaryContactPhone}</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </Paper>
        )
    }
}